<template>
  <div>
    <vx-card titleIcon="SearchIcon" ref="filterCard" title="Audit Log Summary" class="user-list-filters mb-8" :collapse-action="true">
      <RawMaterialAuditStockLogSummary/>
    </vx-card>
    <vx-card>
      <div class="vx-row">
        <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
          <label class="text-sm opacity-100 text-bold">General</label>
          <vs-input type="search"  placeholder="Search.." v-model="filters['search']" class="mb-4 md:mb-0 w-full"/>
        </div>
        <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
          <label class="text-sm opacity-100 text-bold">Status</label>
          <v-select  :clearable="true" placeholder=""  v-model="filters['status']"
                     :options="['Approved', 'Suspended - Level 1']"
                     :dir="$vs.rtl ? 'rtl' : 'ltr'"></v-select>
        </div>
      </div>
      
      <div class="vx-row">
      <div class="vx-col w-full">
        <vx-card title="" v-can="'view-raw-material-stock-inventory'">
          <div slot="no-body" class="mt-4">
            <vs-table id="raw-material-stock-table" max-items="10" :data="rm_list"  sort  stripe class="table-dark-inverted table-auto vs-con-loading__container">

              <template slot="thead">
                <vs-th  class="text-sm" sort-key="company_product_code">PRODUCT CODE</vs-th>
                <vs-th  class="text-sm" sort-key="company_product_name">PRODUCT NAME</vs-th>
                <vs-th width="10%" class="text-sm">RM STATUS</vs-th>
                <vs-th  class="text-sm">ACTION</vs-th>
              </template>

              <template slot-scope="{data}">
                <vs-tr class="cursor-pointer" @click.native="onClickViewRmStock(tr.id)" :key="indextr" v-for="(tr, indextr) in data">

                  <vs-td :data="data[indextr].company_product_code">
                    {{ data[indextr].company_product_code ? data[indextr].category.prefix+ ' - ' +data[indextr].company_product_code  : '-' }}
                  </vs-td>
                  <vs-td :data="data[indextr].company_product_name">
                    {{ data[indextr].company_product_name ?data[indextr].company_product_name : '-' }}
                  </vs-td>
                 <vs-td :data="data[indextr].is_approved">
                    <vs-chip style="border-radius: 0" class="w-full" transparent :color="statusColorFactory(data[indextr].status ? data[indextr].status.id : '')">
                      {{data[indextr].status ? data[indextr].status.name : ''}}
                    </vs-chip>
                  </vs-td>

                  <vs-td>
                    <div class="vx-row">
                      <vx-tooltip text="View Log" position="left">
                        <vs-button class="ml-3"
                                   @click.stop="onClickViewRmStock(data[indextr].id)"
                                   size="small" color="primary" type="border" icon-pack="feather" icon="icon-eye"></vs-button>
                      </vx-tooltip>
                    </div>
                  </vs-td>
                </vs-tr>
              </template>


            </vs-table>
            <vs-pagination
              v-on:changeMaxItems="changePage"
              :size-array="meta.total ? meta.total : 20"
              :max-items="perPage"
              description-body="Rows per page"
              description-connector="of"
              description-title="Records"
              description
              :description-items="descriptionItems"
              :total="(meta.last_page)? meta.last_page : 0"
              v-model="page"  class="p-5">
            </vs-pagination>

          </div>
        </vx-card>
      </div>
    </div>
    </vx-card>
  </div>
</template>

<script>
  import vSelect from 'vue-select'
  import { RepositoryFactory } from '@/repository/RepositoryFactory'
  import Filter from '@/mixins/filter';
  const SupplierRawMaterialRepository = RepositoryFactory.get('supplierRawMaterial')
  import {defaultPagination, perPageList} from "@/constants/config";
  import RawMaterialAuditStockLogSummary from './RawMaterialAuditStockLogSummary.vue';

  export default {
    name: 'RawMaterialList',
    data () {
      return {
        rm_list: [],
        filters: {},
        page : 1,
        total: 0,
        meta : {},
        sort : '',
        perPage: defaultPagination,
        descriptionItems: perPageList,
      }
    },
    components: {
      'v-select': vSelect,
      RawMaterialAuditStockLogSummary,
    },
    mixins : [Filter],
    methods: {
      async refreshData () {
        this.fetchRawMaterialList()
      },
      async fetchRawMaterialList() {
        await this.$vs.loading({
          container: '#raw-material-stock-table',
          scale: 0.45
        })
        this.supplierId = this.$route.params.id
        const {data} = await SupplierRawMaterialRepository.getRawMaterialAcceptedList(this.page, this.filterQuery, this.perPage, this.sort)
        this.rm_list =  data.data
        this.meta = data.meta
        this.$vs.loading.close('#raw-material-stock-table > .con-vs-loading')
      },
      async onClickViewRmStock(id) {
        this.$router.push(`/pages/activity-logs/rm-stock-adjust/${id}/rm-batch`)
      },
      filterQueryUpdate (){
        this.page = 1
        this.fetchRawMaterialList()
      },
      handleChangePage(page) {
        this.page=page;
        this.fetchRawMaterialList()
      },

      handleSort(key, active) {
        if(key){
          active = (active==='desc')? "-":'';
          this.sort=active+key;
          this.fetchRawMaterialList()
        }

      },
      changePage(index) {
        this.page = 1
        this.perPage = this.descriptionItems[index]
      },
      statusColorFactory(id) {
        switch (id) {
          case 1:
            return 'warning'
          case 2:
            return 'danger'
          case 3:
            return 'success'
          default:
            return 'danger'
        }
      },

    },
    watch : {
      page(){
        this.fetchRawMaterialList()
      },
      perPage() {
        this.fetchRawMaterialList()
      }
    }
  }
</script>


<style scoped>

</style>
